import styled, { css } from 'styled-components';
import Image from '@klv/atoms/image';
import Grid from '@klv/utils/grid';

const cardTransition = css`transition: .45s ease-in-out;`;

export const CardContentsContainer = styled.div`
  grid-column: 1 / -1;
  padding: 0 0 2.4rem 0;
  text-align: center;
  max-width: 54rem;
  margin: auto;
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      padding: 0 2.4rem 2.4rem 2.4rem;
      margin: 0;
      grid-column: 1 / span 4;
    }
  `}
`;

export const StyledButton = styled.div`
  ${({ theme }) => `
    display: inline-block;
    border-radius: 3.2rem;
    ${theme.fonts.sohne.semibold}
    font-size: 1.6rem;
    font-weight: 500;
    text-align: center;
    line-height: 2.0rem;
    padding: 1rem 2.8rem;
    width: 100%;
    max-width: 28.9rem;
    margin-bottom: 1.6rem;
    ${cardTransition}
    color: ${theme.colors.white};
    background-color: ${theme.colors.charcoal};
    border: 2px solid ${theme.colors.charcoal};
    
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 43.4rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 53.4rem;
    }

    ${theme.screenSize.s1024.mediaQuery} {
      margin-bottom: 1.8rem;
      font-size: 1.8rem;
      max-width: 27rem
    }
    ${theme.screenSize.s1200.mediaQuery} {
      margin-bottom: 2.2rem;
    } 
  `}
`;


export const ImageContainer = styled.div`
  grid-column: 1 / -1;
  padding-left: 2.5rem;
  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      padding-left: 3rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      padding-left: 4.5rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      padding-left: 0rem;
      grid-column: 5 / -1;
    }
  `}  
`;

export const CardDesktopImage = styled(Image)`
${({ theme }) => `
  display: none;
  ${theme.screenSize.s576.mediaQuery} {
    display: block;
    width: 100% !important;
  }
`}`;

export const CardMobileImage = styled(Image)`
${({ theme }) => `
  display: block;
  width: 100%;
  max-width: 100%;
  ${theme.screenSize.s576.mediaQuery} {
    display: none;
  }
`}`;

export const SubHeadline = styled.p`
  font-family: "Sohne";
  font-size: 1.6rem;
  line-height: 1.5;
  text-align: center;
  
  ${({ theme }) => `
    ${theme.screenSize.s1200.mediaQuery} {
      line-height: 1.3;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 1.8rem;
    }
  `}
`;

export const StyledProductsCard = styled(Grid)`
  width: 100%;
  padding-top: 2.4rem;
  background: linear-gradient(265.76deg, rgba(236, 217, 186, 0.1) 25.53%, rgba(233, 220, 198, 0) 95.6%);
  border-radius: 1.5rem;
  padding-left: 0;
  padding-right: 0;
  border-radius: 1.5rem;
  text-decoration: none;
  margin-top: 2.4rem;
  ${cardTransition}
  ${({ theme }) => `
    border: 1px solid ${theme.colors.sand};
    background: linear-gradient(145deg, ${theme.colors.sand} 0%, rgba(0,0,0,0) 55%);
    ${theme.screenSize.s1024.mediaQuery} {
      margin-top: 0rem;
      padding-top: 2.8rem;
      border: 1px solid ${theme.colors.sandTint};
      background: linear-gradient(145deg, ${theme.colors.sand} 0%, rgba(0,0,0,0) 35%);
      background-repeat: no-repeat;
      background-size: 0 0;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      padding-top: 3.2rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      padding-top: 3.6rem;
    }
  `}

  &:hover, &:focus {
    outline: none;

    ${({ theme }) => `
      ${theme.screenSize.s1024.mediaQuery} {
        border: 1px solid ${theme.colors.sand};
        background-size: 100% 100%;
        cursor: pointer;
        box-shadow: 0px 0px 10px rgba(174, 161, 141, 0.51);

        ${StyledButton} {
          background-color: ${theme.colors.transparent};
          color: ${theme.colors.charcoal};
        }
      }
      &:focus-visible {
        outline: 1px dashed ${theme.colors.charcoal};
        outline-offset: 2px;
        border-radius: 1.5rem;

        ${theme.screenSize.s1024.mediaQuery} {
          outline: none;
        }
      }
    `}
  }
`;

